import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ScheduleKLogo } from '../../../assets/icons/svg/large-icons/ic-large-form-1065.svg';
import { ReactComponent as Form1120sLogo } from '../../../assets/icons/svg/large-icons/ic-large-form-1120s.svg';
import { ReactComponent as Form1120Logo } from '../../../assets/icons/svg/large-icons/ic-large-form-1120.svg';
import Heading from '../../../generic-components/Heading';
import { ProfilePlanPromotion } from '../../../flows/profile/components/ProfilePlanPromotion';
import { useStore } from '../../../store';
import { UPGRADE_DISCLAIMER_MAP } from '../consts';

export const Upgrade = () => {
  const { formType } = useParams();
  const summaryData = useStore((state) => state.summary);
  const { t } = useTranslation();
  const getLogoByType = () => {
    if (formType === 'ScheduleK') {
      return <ScheduleKLogo className='mb-[12px]' />;
    }
    if (formType === 'Form1120s') {
      return <Form1120sLogo className='mb-[12px]' />;
    }
    if (formType === 'Form1120') {
      return <Form1120Logo className='mb-[12px]' />;
    }
    return '';
  };
  return (
    <div className='flex flex-col h-full fadeIn bg-bw00 rounded-[8px]'>
      <Heading
        title={t(UPGRADE_DISCLAIMER_MAP[formType as keyof typeof UPGRADE_DISCLAIMER_MAP].header)}
        className='py-[16px] px-[24px] border-b border-b-bw03 font-metricRMedium text-[24px] text-bw08'
      />
      <div className='flex flex-col w-full h-full items-center justify-center'>
        {getLogoByType()}
        <Heading
          title={t(UPGRADE_DISCLAIMER_MAP[formType as keyof typeof UPGRADE_DISCLAIMER_MAP].title)}
          className='font-metricRMedium text-[24px] text-bw08 mb-[14px]'
        />
        <Heading
          title={t(UPGRADE_DISCLAIMER_MAP[formType as keyof typeof UPGRADE_DISCLAIMER_MAP].subtitle)}
          className='font-metricR text-[16px] text-bw07 mb-[30px]'
        />
        <ProfilePlanPromotion
          customTitle={t(UPGRADE_DISCLAIMER_MAP[formType as keyof typeof UPGRADE_DISCLAIMER_MAP].action)}
          planType={summaryData.customerProfileInfo.customerProfile}
          shouldAppearAsButton
        />
      </div>
    </div>
  );
};
